import { createAction, createReducer } from 'redux-act';
import { API_INSTANCE } from '../../../utils/service-http';
import { getAppLocale } from '../../../utils/app-locale';
import { api_base_url } from '../../../constants';
import { appConfiguration } from '../../../utils/app-starter';

/**
 * Reducer and action used to check if we have to display the configuration restore prompt on startup page.
 * It should be shown only on the first time we arrive at the page.
 */
export const updateHandleConfigurationRestore = createAction('UPDATE_HANDLE_CONFIGURATION_RESTORE');
const DEFAULT_HANDLE_CONFIGURATION_RESTORE = true;
export const shouldHandleConfigurationRestore = createReducer(function (on, off) {
  on(updateHandleConfigurationRestore, (state, payload) => { return payload });
}, DEFAULT_HANDLE_CONFIGURATION_RESTORE);


/**
 * Reducer and action used to retrieve the configurations saved in DynamoDB, given a session ID.
 */
const DEFAULT_STATE = { configurations: [], error: null };

const getSavedConfigurationStarted = createAction('GET_SAVED_CONFIGURATION_STARTED');
const getSavedConfigurationSuccess = createAction('GET_SAVED_CONFIGURATION_SUCCESS');
const getSavedConfigurationFailed = createAction('GET_SAVED_CONFIGURATION_FAILED');

const getSavedConfigurationByIDStarted = createAction('GET_SAVED_CONFIGURATION_BY_ID_STARTED');
const getSavedConfigurationByIDSuccess = createAction('GET_SAVED_CONFIGURATION_BY_ID_SUCCESS');
const getSavedConfigurationByIDFailed = createAction('GET_SAVED_CONFIGURATION_BY_ID_FAILED');

export const getSavedConfigurationsReducer = createReducer(function (on, off) {
  on(getSavedConfigurationStarted, (state, payload) => {
    return {
      configurations: [],
      error: null,
    };
  });
  on(getSavedConfigurationSuccess, (state, payload) => {
    return {
      configurations: payload,
      error: null,
    };
  });
  on(getSavedConfigurationFailed, (state, payload) => {
    return {
      configurations: [],
      error: null,
    };
  });
  on(getSavedConfigurationByIDStarted, (state, payload) => {
    return {
      ...state,
      error: null
    };
  });
  on(getSavedConfigurationByIDSuccess, (state, payload) => {
    return {
      ...state,
      error: null,
    };
  });
  on(getSavedConfigurationByIDFailed, (state, payload) => {
    return {
      ...state,
      error: null,
    };
  });
}, DEFAULT_STATE);

export function getSavedConfigurations() {
  const mainOverrideString = appConfiguration.main ? `&main=${appConfiguration.main}` : '';
  const seamlessIdString = appConfiguration.seamlessSession ? `&seamlessId=${appConfiguration.seamlessSession.id}` : '';
  return async dispatch => {
    dispatch(getSavedConfigurationStarted());
    return API_INSTANCE.get(`${api_base_url}/configurations?locale=${getAppLocale()}${mainOverrideString}${seamlessIdString}&t=${new Date().getTime()}`)
      .then((success) => {
        dispatch(getSavedConfigurationSuccess(success.data.payload.savedConfigurations));
        return success.data.payload;
      }).catch((error) => {
        dispatch(getSavedConfigurationFailed(error.message));
        throw error;
      });
  }
}

export function getSavedConfigurationByID(configurationID) {
  const mainOverrideString = appConfiguration.main ? `&main=${appConfiguration.main}` : '';
  return async dispatch => {
    dispatch(getSavedConfigurationByIDStarted());
    return API_INSTANCE.get(`${api_base_url}/configurations/${configurationID}?locale=${getAppLocale()}${mainOverrideString}&t=${new Date().getTime()}`)
      .then((success) => {
        dispatch(getSavedConfigurationByIDSuccess());
        return success.data.payload;
      }).catch((error) => {
        dispatch(getSavedConfigurationByIDFailed(error.message));
        throw error;
      });
  }
}


/**
 * Reducer and action used to check if we want to trigger the survey and add to my products button animation.
 */
const updateShowButtonAnimationsAction = createAction('UPDATE_SHOW_BUTTON_ANIMATIONS');
const DEFAULT_SHOW_BUTTON_ANIMATIONS = {
  addToMyProduct: true,
  survey: true
};
export const showButtonAnimations = createReducer(function (on, off) {
  on(updateShowButtonAnimationsAction, (state, payload) => {
    return {...state, ...payload};});
}, DEFAULT_SHOW_BUTTON_ANIMATIONS);

export const updateShowButtonAnimations = (newState) => {
  return async dispatch => {
    dispatch(updateShowButtonAnimationsAction(newState));
  }
}
